import type { IToolingBaseComposableDataItem } from './use-tooling-base'
import type { IToolingFormComposableData } from './use-tooling-form/types'
import { ArrayUtils } from '../utils/array.utils'
import { useContextQuery } from './use-context-query'

export function useUpdateItemWithContext<DataItemType extends IToolingBaseComposableDataItem>() {
  const { query, setQuery } = useContextQuery()

  const updateItemWithContext = async (item: IToolingFormComposableData<DataItemType>['item']) => {
    if (query.value?.trim() && typeof item.value.criteria.queries !== 'undefined') {
      item.value.criteria.queries = ArrayUtils.addUniqueItems(item.value.criteria.queries, [
        query.value.trim(),
      ])
      setQuery('')
    }
  }

  return {
    updateItemWithContext,
  }
}
